import React from 'react';
import {
    Box, Button, Container, Typography,
} from '@mui/material';
import {
    Analytics as AnalyticsIcon,
    Refresh as RefreshIcon,
} from '@mui/icons-material';

import PageLoader from '../PageLoader';

// ── Loading state ───────────────────────────────────────────────────────────
export const DashboardLoading = () => (
    <Box sx={{ py: 4 }}>
        <PageLoader type="dashboard" />
    </Box>
);

// ── Empty state ───────────────────────────────────────────────────────────────
export const DashboardEmpty = ({ onRefresh }) => (
    <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', py: 10 }}>
            <AnalyticsIcon
                sx={{ fontSize: 80, color: 'text.secondary', mb: 3, opacity: 0.4 }}
            />
            <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 2 }}
            >
                No Analytics Data Yet
            </Typography>
            <Typography
                variant="h6"
                sx={{
                    color: 'text.secondary',
                    mb: 4,
                    maxWidth: 560,
                    mx: 'auto',
                    fontWeight: 400,
                }}
            >
                Start posting content to see your social media performance analytics
                here. Your engagement metrics, views, and platform distribution will
                appear once you have published posts.
            </Typography>
            <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={onRefresh}
                sx={{
                    borderRadius: 3,
                    px: 4,
                    py: 1.5,
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    boxShadow: '0 4px 14px 0 rgba(99,102,241,0.35)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #5855eb, #7c3aed)',
                        boxShadow: '0 6px 20px rgba(99,102,241,0.45)',
                    },
                }}
            >
                Refresh Data
            </Button>
        </Box>
    </Container>
);
